import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog"
import { RefinedDataItem } from "@/lib/useQuery/useGetExportData"
import { CircleHelp } from "lucide-react"
import { useState } from "react"
import RenderValue from "./RenderValue"
import TableCellError from "./tableCellErrors"

type Params = {
    field: RefinedDataItem[string],
    columnName: string
}

export function ValidationTableCell({ field, columnName }: Readonly<Params>) {
    const [showDialog, setShowDialog] = useState(false)
    if (!field) return null
    return (
        <div className="p-2 data-[valid=false]:bg-red-500/40 h-full rounded" data-valid={field?.isValid}>
            <Dialog open={showDialog} onOpenChange={setShowDialog}>
                <DialogContent className="max-w-lg">
                    <DialogHeader>
                        <DialogTitle>
                            <p className="text-base font-normal">
                                An Error occurred for column{" "}
                                <span className="font-bold">{columnName}</span>
                                {" "}with value{" "}
                                <span className="font-bold">
                                    <RenderValue value={field?.value} />
                                </span>
                            </p>
                        </DialogTitle>
                    </DialogHeader>
                    <TableCellError field={field} />
                </DialogContent>
            </Dialog>
            <div className="w-full">
                {field?.isValid ? (
                    <div className="truncate">
                        <RenderValue value={field?.value} />
                    </div>
                ) : (
                    <button className="flex items-center justify-center w-full gap-2 font-bold text-red-800 cursor-pointer" onClick={() => setShowDialog(true)}>
                        {field.errors.length === 1 ? (<span>Error</span>) : (<span>{field.errors.length} Errors</span>)} <CircleHelp size={18} />
                    </button>
                )}
            </div>
        </div>
    )
}

